/**
 * @generated SignedSource<<91da30109ed390efecd21f0a6443e91b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee$data = {
  readonly id: string;
  readonly notifyWhenRoleAssigneeEnabled: boolean | null | undefined;
  readonly " $fragmentType": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee";
};
export type assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee$key = {
  readonly " $data"?: assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee$data;
  readonly " $fragmentSpreads": FragmentRefs<"assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "ScalarField",
      "name": "notifyWhenRoleAssigneeEnabled"
    }
  ],
  "type": "JiraNotificationOptions"
};

(node as any).hash = "9f7680926b28a65e720c5553ad6818fb";

export default node;
